export default "__VITE_ASSET__9e7a6040__"